<template>
  <el-select
    :value="value"
    size="small"
    @change="handleChange"
    placeholder="请选择基地"
    style="width: 100%"
    :disabled="disabled"
    :filterable="!multiple"
    :multiple="multiple"
    :collapse-tags="true"
  >
    <el-option
      v-if="clearable"
      :key="0"
      :label="multiple ? `${value.length == 0 ? '全选' : '取消全选'}` : '不限'"
      :value="0"
    ></el-option>
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    ></el-option>
  </el-select>
</template>

<script>
import { baseList } from '@/service/getData'

export default {
  props: {
    value: '',
    clearable: {
      type: Boolean,
      default: false,
    },
    filterBlank: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    stockOutProductId: {
      type: Number,
      default: 0,
    },
    authLimit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lists: [],
    }
  },
  watch: {
    stockOutProductId() {
      this.getList()
    },
  },
  created() {
    this.getList()
  },
  computed: {
    multiple() {
      return typeof this.value == 'object'
    },
  },
  methods: {
    async getList() {
      let res = await baseList({
        filter_blank: this.filterBlank,
        stock_out_product_id: this.stockOutProductId,
        auth_limit: this.authLimit,
      })
      if (res.status == 0) {
        this.lists = res.data
      }
    },
    handleChange(e) {
      let val = e
      if (this.multiple && e.includes(0)) {
        if (val.length > 1) {
          val = []
        } else {
          val = this.lists.map((item) => {
            return item.id
          })
        }
      }
      this.$emit('input', val)
    },
  },
}
</script>
<style>
.select-err .el-input__inner {
  border-color: #f56c6c;
}
</style>